<template>
    <div>

          <!-- <upload-image :inputId="inputId" ref="uploadBackground" :image="deck_background" @newImageSrc="update_input_from_upload" editbutton="true" @editingImage="hideChooseButton" @stopEditingImage="showChooseButton"></upload-image> -->
          <div class="row justify-content-center">
            <div class="col-4">
              <img :src="deck_background" class="d-block mx-auto mb-3 w-100" v-b-modal.modal-medialib-deckbg />
            </div>
          </div>
          <div class="text-center">
            <b-button v-show="libraryButton" v-b-modal.modal-medialib-deckbg>Select Background</b-button>

            <b-modal id="modal-medialib-deckbg" title="Media Library" size="xl" :hide-footer="true">
              <sd-media-manager :defaultTab="defaultTab" :defaultColor="imgColor" prefix="/sd-media/" @selectedImageFromLibrary="update_input_from_lib" @cancel="$bvModal.hide('modal-medialib-deckbg');"></sd-media-manager>
            </b-modal>

          </div>

          <input :ref="input_name" type="hidden" :name="input_name" :value="deck_background">

    </div>
</template>

<script>
    export default {
        mounted() {

          if(this.deck_background){ // If deck_background is set

            if(this.deck_background.startsWith("data:image")){ 
              this.defaultTab = '#solidcolors'; // solid colors tab
            }else{

              if(this.deck_background.includes("/user_")){
                this.defaultTab = 'user'; // user tab
              }else{
                if(this.deck_background && this.deck_background.includes("/storage/company")){
                  this.defaultTab = ''; // company tab
                }else{
                  this.defaultTab = 'backgrounds'; // backgrounds tab
                }
              }

            }
            this.setImgColor();
          }



        },
         props: [
            'image',
            'name',
            'inputId',
        ],
        data: function(){

            return {
                deck_background: this.image,
                input_name: this.name,
                libraryButton: true,
                defaultTab: 'backgrounds',
                imgColor: '#e4e1dd',
            }
        },

        methods: {
          update_input_from_lib: function(background){
            this.deck_background =  background.src;
            //this.$refs.uploadBackground.imageSrc = background.src;
            this.$emit('change', background.src)
            this.$bvModal.hide('modal-medialib-deckbg');
          },
          update_input_from_upload: function(background){
          	this.deck_background =  background.src;
            this.$emit('change', background.src)
            this.$bvModal.hide('modal-medialib-deckbg');
          },
          hideChooseButton: function(){
            this.libraryButton = false;
          },
          showChooseButton: function(){
            this.libraryButton = true;
          },
          componentToHex: function(c) {
            var hex = c.toString(16);
            return hex.length == 1 ? "0" + hex : hex;
          },
          rgbToHex: function(r, g, b) {
            return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
          },
          setImgColor: function(){
          var vm = this;
            if(vm.deck_background){

              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              var img = new Image();
              img.src = vm.deck_background;
              img.onload = function() {
                  ctx.drawImage(img, 0, 0);
                  var data = ctx.getImageData(0, 0, 1, 1).data;
                  vm.imgColor = vm.rgbToHex(data[0],data[1],data[2]);  
              }
            
            }
          }
      },
      watch: {
        deck_background : function(){
            if(this.deck_background.startsWith("data:image")){ 
              this.defaultTab = '#solidcolors'; // solid colors tab
            }else{

              if(this.deck_background.includes("/user_")){
                this.defaultTab = 'user'; // user tab
              }else{
                if(this.deck_background && this.deck_background.includes("/storage/company")){
                  this.defaultTab = ''; // company tab
                }else{
                  this.defaultTab = 'backgrounds'; // backgrounds tab
                }
              }

            }
            this.setImgColor();
        }
      }
    }
</script>



